import React from "react";
import { redirect, useLoaderData } from "react-router-dom";
import TabLayout from "../../helpers/TabLayout";
import ImagesTable from "./ImagesTable";
import { testSessionLoader } from "../../../loaders/helpers";
import { imageList } from "../../../api/image";

const imagesTabLoader = async (params) => {
  await testSessionLoader(params);
  const url = new URL(params.request.url);
  let page = Number(url.searchParams.get("page"));
  page = isNaN(page) ? 0 : page;
  const imagesListRes = await imageList(page);
  const images = imagesListRes.data;
  if (!images.length && page !== 0) throw redirect("?page=0");
  return { imagesList: images, page };
};

const ImagesTab = () => {
  const { imagesList } = useLoaderData();
  let { page } = useLoaderData();

  const onPageButtonClicked = (newPage) => page = newPage;

  return (
    <>
      <TabLayout
        headerLabel="Images"
        skeletonLines={16}
      >
        <ImagesTable
          imagesList={imagesList}
          currentPage={page}
          onPageButtonClicked={onPageButtonClicked}
        />
      </TabLayout>
    </>
  );
};

export { imagesTabLoader };
export default ImagesTab;